import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

export type LandingEventFilter = 'all' | 'active' | 'upcoming';

type LandingSearchContextValue = {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  eventFilter: LandingEventFilter;
  setEventFilter: (filter: LandingEventFilter) => void;
};

const LandingSearchContext = createContext<LandingSearchContextValue | null>(null);

export function LandingSearchProvider({ children }: { children: ReactNode }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [eventFilter, setEventFilter] = useState<LandingEventFilter>('all');

  const value = useMemo(
    () => ({ searchQuery, setSearchQuery, eventFilter, setEventFilter }),
    [searchQuery, eventFilter]
  );

  return <LandingSearchContext.Provider value={value}>{children}</LandingSearchContext.Provider>;
}

/** Null when the landing page is not mounted — directory can fall back to local state. */
export function useLandingSearch(): LandingSearchContextValue | null {
  return useContext(LandingSearchContext);
}
